const productListCarouselMediaQuery = matchMedia('(max-width: 768px)');

/**
 * Toggles slideshow behavior for product lists: carousel at ≤768px, static grid above.
 */
class ProductListCarousel extends HTMLElement {
  /** @type {HTMLElement | null} */
  #slideshow = null;

  connectedCallback() {
    productListCarouselMediaQuery.addEventListener('change', this.#syncLayout);
    this.#initSlideshow();
  }

  disconnectedCallback() {
    productListCarouselMediaQuery.removeEventListener('change', this.#syncLayout);
  }

  #initSlideshow = () => {
    const slideshow = this.querySelector('slideshow-component');
    if (!(slideshow instanceof HTMLElement)) return;

    if (!this.#getListSlides(slideshow).length) {
      requestAnimationFrame(this.#initSlideshow);
      return;
    }

    this.#slideshow = slideshow;
    this.#syncLayout();
  };

  #getListSlides(slideshow) {
    return slideshow?.refs?.slides?.filter((slide) => slide.classList.contains('resource-list__slide')) ?? [];
  }

  #syncLayout = () => {
    const slideshow = this.#slideshow;
    const slides = this.#getListSlides(slideshow);
    if (!slideshow || !slides.length) return;

    if (productListCarouselMediaQuery.matches) {
      slideshow.setAttribute('disabled', 'false');
      slideshow.select(0, undefined, { animate: false });
      return;
    }

    slideshow.setAttribute('disabled', 'true');
    slides.forEach((slide) => slide.setAttribute('aria-hidden', 'false'));
  };
}

if (!customElements.get('product-list-carousel')) {
  customElements.define('product-list-carousel', ProductListCarousel);
}
